export const currenciesMock = {
  "currencies": [
      {
          "tokenName": "GTC",
          "tokenSymbol": "GTC",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GTC.webp",
          "tokenAddress": "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
          "tokenBalance": 14452761.950885434,
          "usdValue": 4021920.229322624,
          "currencyPercentage": 38.24563484207222,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "ETH",
          "tokenSymbol": "ETH",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "tokenAddress": "eth",
          "tokenBalance": 846.0196776240298,
          "usdValue": 3486009.615962766,
          "currencyPercentage": 33.149501538104616,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "ENS",
          "tokenSymbol": "ENS",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ENS.webp",
          "tokenAddress": "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
          "tokenBalance": 46351.39685104236,
          "usdValue": 936812.1133305973,
          "currencyPercentage": 8.90842482176887,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "RAD",
          "tokenSymbol": "RAD",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/RAD.webp",
          "tokenAddress": "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
          "tokenBalance": 680272.108,
          "usdValue": 420103.2211352932,
          "currencyPercentage": 3.9948863914252177,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "USDC",
          "tokenSymbol": "USDC",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "tokenAddress": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
          "tokenBalance": 411593.596072,
          "usdValue": 411346.78799920046,
          "currencyPercentage": 3.9116188661768545,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "AKITA",
          "tokenSymbol": "AKITA",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AKITA.webp",
          "tokenAddress": "0x3301ee63fb29f863f2333bd4466acb46cd8323e6",
          "tokenBalance": 6000000000000,
          "usdValue": 289334.4834444234,
          "currencyPercentage": 2.751367598083545,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "AAVE",
          "tokenSymbol": "AAVE",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AAVE.webp",
          "tokenAddress": "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
          "tokenBalance": 867.1922770347235,
          "usdValue": 237654.3117200942,
          "currencyPercentage": 2.259925484952134,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "UNI",
          "tokenSymbol": "UNI",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UNI.webp",
          "tokenAddress": "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
          "tokenBalance": 17234.071860848017,
          "usdValue": 132935.34794101483,
          "currencyPercentage": 1.264121734162827,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "SYND",
          "tokenSymbol": "SYND",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SYND.webp",
          "tokenAddress": "0x1bab804803159ad84b8854581aa53ac72455614e",
          "tokenBalance": 199999.99999999997,
          "usdValue": 111719.99999999999,
          "currencyPercentage": 1.0623786850382007,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "USDGLO",
          "tokenSymbol": "USDGLO",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDGLO.webp",
          "tokenAddress": "0x4f604735c1cf31399c6e711d5962b2b3e0225ad3",
          "tokenBalance": 99999.99999999999,
          "usdValue": 99902.14782273585,
          "currencyPercentage": 0.9499992162227898,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "MASK",
          "tokenSymbol": "MASK",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MASK.webp",
          "tokenAddress": "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
          "tokenBalance": 70560.0841143992,
          "usdValue": 87189.50216164145,
          "currencyPercentage": 0.8291108902221628,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "GNO",
          "tokenSymbol": "GNO",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GNO.webp",
          "tokenAddress": "0x6810e776880c02933d47db1b9fc05908e5386b96",
          "tokenBalance": 411.2615,
          "usdValue": 58127.700410000005,
          "currencyPercentage": 0.5527535797159892,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "RAI",
          "tokenSymbol": "RAI",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/RAI.webp",
          "tokenAddress": "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919",
          "tokenBalance": 8272.02284990355,
          "usdValue": 37935.09148451561,
          "currencyPercentage": 0.3607360598650514,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "RPL",
          "tokenSymbol": "RPL",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VOTE.webp",
          "tokenAddress": "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
          "tokenBalance": 7686.54057666524,
          "usdValue": 37586.24936826991,
          "currencyPercentage": 0.35741881650000445,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "DAI",
          "tokenSymbol": "DAI",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
          "tokenAddress": "0x6b175474e89094c44da98b954eedeac495271d0f",
          "tokenBalance": 36644.16482812795,
          "usdValue": 36640.50041164514,
          "currencyPercentage": 0.34842540857917315,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "ALCX",
          "tokenSymbol": "ALCX",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ALCX.webp",
          "tokenAddress": "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
          "tokenBalance": 2940,
          "usdValue": 25071.64209309739,
          "currencyPercentage": 0.23841369637140364,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "USDC",
          "tokenSymbol": "USDC",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "tokenAddress": "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
          "tokenBalance": 22552.620327,
          "usdValue": 22539.096868878674,
          "currencyPercentage": 0.21433097111983493,
          "chainId": "137",
          "chainTitle": "Polygon"
      },
      {
          "tokenName": "SNX",
          "tokenSymbol": "SNX",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SNX.webp",
          "tokenAddress": "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
          "tokenBalance": 17335.095,
          "usdValue": 17997.524515294277,
          "currencyPercentage": 0.17114380977892157,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "DAI",
          "tokenSymbol": "DAI",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
          "tokenAddress": "0x8f3cf7ad23cd3cadbd9735aff958023239c6a063",
          "tokenBalance": 8045.167683319779,
          "usdValue": 8044.363166551447,
          "currencyPercentage": 0.07649624026898195,
          "chainId": "137",
          "chainTitle": "Polygon"
      },
      {
          "tokenName": "SAFE",
          "tokenSymbol": "SAFE",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SAFE.webp",
          "tokenAddress": "0x5afe3855358e112b5647b952709e6165e1c1eeee",
          "tokenBalance": 17211.296996959896,
          "usdValue": 6358.884824389679,
          "currencyPercentage": 0.06046852576122877,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "BAL",
          "tokenSymbol": "BAL",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BAL.webp",
          "tokenAddress": "0xba100000625a3754423978a60c9317c58a424e3d",
          "tokenBalance": 5487.1358073324145,
          "usdValue": 6051.589079434775,
          "currencyPercentage": 0.05754635918905704,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "GRT",
          "tokenSymbol": "GRT",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GRT.webp",
          "tokenAddress": "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
          "tokenBalance": 56760.7080645162,
          "usdValue": 4654.529014660284,
          "currencyPercentage": 0.04426129980367835,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "Legacy Frax Dollar",
          "tokenSymbol": "Legacy Frax Dollar",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LEGACY FRAX DOLLAR.webp",
          "tokenAddress": "0x853d955acef822db058eb8505911ed77f175b99e",
          "tokenBalance": 4000,
          "usdValue": 3990.7849766907298,
          "currencyPercentage": 0.037949560470881716,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "SAI",
          "tokenSymbol": "SAI",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SAI.webp",
          "tokenAddress": "0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359",
          "tokenBalance": 175.95,
          "usdValue": 3815.5768207693363,
          "currencyPercentage": 0.036283454041453334,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "WETH",
          "tokenSymbol": "WETH",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "tokenAddress": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
          "tokenBalance": 0.6171307371126914,
          "usdValue": 2542.8933735772166,
          "currencyPercentage": 0.02418112887946042,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "PUSH",
          "tokenSymbol": "PUSH",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PUSH.webp",
          "tokenAddress": "0xf418588522d5dd018b425e472991e52ebbeeeeee",
          "tokenBalance": 78432.00000000001,
          "usdValue": 2268.1797152117274,
          "currencyPercentage": 0.021568795052604332,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "USDT",
          "tokenSymbol": "USDT",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDT.webp",
          "tokenAddress": "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
          "tokenBalance": 1434.986381,
          "usdValue": 1435.5173259609699,
          "currencyPercentage": 0.013650760912137214,
          "chainId": "137",
          "chainTitle": "Polygon"
      },
      {
          "tokenName": "WETH",
          "tokenSymbol": "WETH",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
          "tokenAddress": "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
          "tokenBalance": 0.24871527188276363,
          "usdValue": 1024.7914833494262,
          "currencyPercentage": 0.009745046800206865,
          "chainId": "137",
          "chainTitle": "Polygon"
      },
      {
          "tokenName": "SACKS",
          "tokenSymbol": "SACKS",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SACKS.webp",
          "tokenAddress": "0xa6610ed604047e7b76c1da288172d15bcda57596",
          "tokenBalance": 1,
          "usdValue": 790.5068313564362,
          "currencyPercentage": 0.00751716441111856,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "AURORA",
          "tokenSymbol": "AURORA",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AURORA.webp",
          "tokenAddress": "0xaaaaaa20d9e0e2461697782ef11675f668207961",
          "tokenBalance": 9176.918586832146,
          "usdValue": 681.8061298243783,
          "currencyPercentage": 0.006483497132597636,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "RAID",
          "tokenSymbol": "RAID",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/XDAI.webp",
          "tokenAddress": "0x18e9262e68cc6c6004db93105cc7c001bb103e49",
          "tokenBalance": 628783.95,
          "usdValue": 613.8351759550366,
          "currencyPercentage": 0.005837141130158471,
          "chainId": null,
          "chainTitle": null
      },
      {
          "tokenName": "POL",
          "tokenSymbol": "POL",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/POL.webp",
          "tokenAddress": "matic",
          "tokenBalance": 2377.246582170848,
          "usdValue": 542.4876700513875,
          "currencyPercentage": 0.005158676490857773,
          "chainId": "137",
          "chainTitle": "Polygon"
      },
      {
          "tokenName": "LRC",
          "tokenSymbol": "LRC",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LRC.webp",
          "tokenAddress": "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
          "tokenBalance": 5770.099999999999,
          "usdValue": 486.99643999999995,
          "currencyPercentage": 0.004630993891384578,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "CYBER",
          "tokenSymbol": "CYBER",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CYBER.webp",
          "tokenAddress": "0x14778860e937f509e651192a90589de711fb88a9",
          "tokenBalance": 300,
          "usdValue": 467.09999999999997,
          "currencyPercentage": 0.004441792729872392,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "wPOKT",
          "tokenSymbol": "wPOKT",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WPOKT.webp",
          "tokenAddress": "0x67f4c72a50f8df6487720261e188f2abe83f57d7",
          "tokenBalance": 11833,
          "usdValue": 309.63730640373007,
          "currencyPercentage": 0.0029444331759395388,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "LINK",
          "tokenSymbol": "LINK",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LINK.webp",
          "tokenAddress": "0x514910771af9ca656af840dff83e8264ecf986ca",
          "tokenBalance": 14.29093,
          "usdValue": 307.1264683788205,
          "currencyPercentage": 0.002920556870897941,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "GLM",
          "tokenSymbol": "GLM",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GLM.webp",
          "tokenAddress": "0x7dd9c5cba05e151c895fde1cf355c9a1d5da6429",
          "tokenBalance": 1075,
          "usdValue": 236.02345234313486,
          "currencyPercentage": 0.0022444171584181534,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "GRT",
          "tokenSymbol": "GRT",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/GRT.webp",
          "tokenAddress": "0x9623063377ad1b27544c965ccd7342f7ea7e88c7",
          "tokenBalance": 1475.4353799312105,
          "usdValue": 120.83914197108219,
          "currencyPercentage": 0.0011490953164015644,
          "chainId": "42161",
          "chainTitle": "Arbitrum"
      },
      {
          "tokenName": "BZZ",
          "tokenSymbol": "BZZ",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BZZ.webp",
          "tokenAddress": "0x19062190b1925b5b6689d7073fdfc8c2976ef8cb",
          "tokenBalance": 698.215,
          "usdValue": 90.70308585767323,
          "currencyPercentage": 0.0008625226018831178,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "REQ",
          "tokenSymbol": "REQ",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/REQ.webp",
          "tokenAddress": "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
          "tokenBalance": 588.8,
          "usdValue": 73.42419305317337,
          "currencyPercentage": 0.0006982124746314118,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "sUSD",
          "tokenSymbol": "sUSD",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SUSD.webp",
          "tokenAddress": "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
          "tokenBalance": 51.654,
          "usdValue": 50.5899276,
          "currencyPercentage": 0.00048107465771451654,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "MATIC",
          "tokenSymbol": "MATIC",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MATIC.webp",
          "tokenAddress": "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
          "tokenBalance": 186.68518484848485,
          "usdValue": 42.55244343923707,
          "currencyPercentage": 0.00040464383195613224,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "MKR",
          "tokenSymbol": "MKR",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MKR.webp",
          "tokenAddress": "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
          "tokenBalance": 0.02495,
          "usdValue": 40.467585782918505,
          "currencyPercentage": 0.0003848183008479015,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "ETH",
          "tokenSymbol": "ETH",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
          "tokenAddress": "arb",
          "tokenBalance": 0.0078297,
          "usdValue": 32.262357147,
          "currencyPercentage": 0.0003067923430188209,
          "chainId": "42161",
          "chainTitle": "Arbitrum"
      },
      {
          "tokenName": "WBTC",
          "tokenSymbol": "WBTC",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WBTC.webp",
          "tokenAddress": "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
          "tokenBalance": 0.00022995,
          "usdValue": 25.7367927285,
          "currencyPercentage": 0.00024473881145725527,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "TUSD",
          "tokenSymbol": "TUSD",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/TUSD.webp",
          "tokenAddress": "0x0000000000085d4780b73119b644ae5ecd22b376",
          "tokenBalance": 17.86,
          "usdValue": 17.8217796,
          "currencyPercentage": 0.00016947259914508266,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "LDO",
          "tokenSymbol": "LDO",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LDO.webp",
          "tokenAddress": "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
          "tokenBalance": 9.916,
          "usdValue": 11.096844020346616,
          "currencyPercentage": 0.00010552318795569156,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "BUSD",
          "tokenSymbol": "BUSD",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BUSD.webp",
          "tokenAddress": "0x4fabb145d64652a948d72533023f6e7a623c7c53",
          "tokenBalance": 8.805,
          "usdValue": 8.897943316734347,
          "currencyPercentage": 0.00008461318761525855,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "USDC",
          "tokenSymbol": "USDC",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
          "tokenAddress": "0x3355df6d4c9c3035724fd0e3914de96a5a83aaf4",
          "tokenBalance": 5.3,
          "usdValue": 5.296821906855887,
          "currencyPercentage": 0.00005036905381567395,
          "chainId": "zkSync Era",
          "chainTitle": "zkSync Era"
      },
      {
          "tokenName": "MANA",
          "tokenSymbol": "MANA",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VP.webp",
          "tokenAddress": "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
          "tokenBalance": 17.93508,
          "usdValue": 5.213702607687626,
          "currencyPercentage": 0.00004957864769544772,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "ELIMU",
          "tokenSymbol": "ELIMU",
          "tokenIcon": null,
          "tokenAddress": "0xe29797910d413281d2821d5d9a989262c8121cc2",
          "tokenBalance": 5145.03,
          "usdValue": 4.641159313701069,
          "currencyPercentage": 0.000044134163343560155,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "SHIB",
          "tokenSymbol": "SHIB",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SHIB.webp",
          "tokenAddress": "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
          "tokenBalance": 375689.88701523474,
          "usdValue": 4.502698672576787,
          "currencyPercentage": 0.00004281749995430881,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "LPT",
          "tokenSymbol": "LPT",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LPT.webp",
          "tokenAddress": "0x58b6a8a3302369daec383334672404ee733ab239",
          "tokenBalance": 0.6525,
          "usdValue": 4.028704028019987,
          "currencyPercentage": 0.000038310144000143004,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "KEEP",
          "tokenSymbol": "KEEP",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/KEEP.webp",
          "tokenAddress": "0x85eee30c52b0b379b046fb0f85f4f3dc3009afec",
          "tokenBalance": 50,
          "usdValue": 3.6275562618046218,
          "currencyPercentage": 0.00003449551066342719,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "SUSHI",
          "tokenSymbol": "SUSHI",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SUSHIPOWAH.webp",
          "tokenAddress": "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
          "tokenBalance": 4.900915,
          "usdValue": 3.2593722455341587,
          "currencyPercentage": 0.000030994339422311026,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "BAT",
          "tokenSymbol": "BAT",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BAT.webp",
          "tokenAddress": "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
          "tokenBalance": 19.25,
          "usdValue": 2.7444092972748413,
          "currencyPercentage": 0.000026097403691778188,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "OUSD",
          "tokenSymbol": "OUSD",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/OUSD.webp",
          "tokenAddress": "0x2a8e1e676ec238d8a992307b495b45b3feaa5e86",
          "tokenBalance": 2.5,
          "usdValue": 2.495928745168224,
          "currencyPercentage": 0.00002373452826925228,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "DIA",
          "tokenSymbol": "DIA",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DIA.webp",
          "tokenAddress": "0x84ca8bc7997272c7cfb4d0cd3d55cd942b3c9419",
          "tokenBalance": 3.96095,
          "usdValue": 2.301924480063969,
          "currencyPercentage": 0.00002188968405108847,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "1INCH",
          "tokenSymbol": "1INCH",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/1INCH.webp",
          "tokenAddress": "0x111111111117dc0aa78b770fa6a738034120c302",
          "tokenBalance": 9.1,
          "usdValue": 2.184647070526591,
          "currencyPercentage": 0.00002077445830700499,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "ZRX",
          "tokenSymbol": "ZRX",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ZRX.webp",
          "tokenAddress": "0xe41d2489571d322189246dafa5ebde1f4699f498",
          "tokenBalance": 8.74,
          "usdValue": 2.0852153794324564,
          "currencyPercentage": 0.000019828932803642018,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "UNI",
          "tokenSymbol": "UNI",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UNI.webp",
          "tokenAddress": "0xb33eaad8d922b1083446dc23f610c2567fb5180f",
          "tokenBalance": 0.222,
          "usdValue": 1.7093005636681047,
          "currencyPercentage": 0.000016254247092416546,
          "chainId": "137",
          "chainTitle": "Polygon"
      },
      {
          "tokenName": "CVX",
          "tokenSymbol": "CVX",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CVX.webp",
          "tokenAddress": "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
          "tokenBalance": 0.47,
          "usdValue": 1.5184880927108435,
          "currencyPercentage": 0.000014439754593450695,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "BADGER",
          "tokenSymbol": "BADGER",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BADGER.webp",
          "tokenAddress": "0x3472a5a71965499acd81997a54bba8d852c6e53d",
          "tokenBalance": 1.6,
          "usdValue": 1.4549157530555754,
          "currencyPercentage": 0.000013835226320914304,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "UBI",
          "tokenSymbol": "UBI",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/VOTE.webp",
          "tokenAddress": "0xdd1ad9a21ce722c151a836373babe42c868ce9a4",
          "tokenBalance": 15573.267400867097,
          "usdValue": 1.4243842094610204,
          "currencyPercentage": 0.000013544892798392198,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "MTV",
          "tokenSymbol": "MTV",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/MTV.webp",
          "tokenAddress": "0x6226e00bcac68b0fe55583b90a1d727c14fab77f",
          "tokenBalance": 3000,
          "usdValue": 1.3297,
          "currencyPercentage": 0.000012644512508908843,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "HAKKA",
          "tokenSymbol": "HAKKA",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/HAKKA.webp",
          "tokenAddress": "0x0e29e5abbb5fd88e28b2d355774e73bd47de3bcd",
          "tokenBalance": 368.5,
          "usdValue": 1.2200878993403943,
          "currencyPercentage": 0.000011602178465201118,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "COMP",
          "tokenSymbol": "COMP",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/CUNI.webp",
          "tokenAddress": "0xc00e94cb662c3520282e6f5717214004a7f26888",
          "tokenBalance": 0.0285,
          "usdValue": 1.182465,
          "currencyPercentage": 0.000011244411133223204,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "PERP",
          "tokenSymbol": "PERP",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/PERP.webp",
          "tokenAddress": "0xbc396689893d065f41bc2c6ecbee5e0085233447",
          "tokenBalance": 4,
          "usdValue": 1.1737329347893106,
          "currencyPercentage": 0.000011161375329820053,
          "chainId": "1",
          "chainTitle": "Ethereum"
      },
      {
          "tokenName": "BIT",
          "tokenSymbol": "BIT",
          "tokenIcon": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/BIT.webp",
          "tokenAddress": "0x1a4b46696b2bb4794eb3d4c26f1c55f9170fa4c5",
          "tokenBalance": 0.64,
          "usdValue": 1.1211730081680242,
          "currencyPercentage": 0.00001066156736589572,
          "chainId": "1",
          "chainTitle": "Ethereum"
      }
  ]
};

export const daoAssetsMock = [
  {
      "rank": 1,
      "protocolName": "Uniswap V3",
      "protocolType": "Liquidity Pool",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
      "totalValue": 549332.24,
      "protocolValuePercentage": 39.87
  },
  {
      "rank": 2,
      "protocolName": "Uniswap V3",
      "protocolType": "Liquidity Pool",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": null,
      "totalValue": 221173.21,
      "protocolValuePercentage": 16.05
  },
  {
      "rank": 3,
      "protocolName": "Sablier",
      "protocolType": "Deposit",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/AKITA.webp",
      "totalValue": 136037.64,
      "protocolValuePercentage": 9.87
  },
  {
      "rank": 4,
      "protocolName": "Uniswap V3",
      "protocolType": "Liquidity Pool",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SACKS.webp",
      "totalValue": 135023.4,
      "protocolValuePercentage": 9.8
  },
  {
      "rank": 5,
      "protocolName": "Uniswap V3",
      "protocolType": "Liquidity Pool",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/WETH.webp",
      "totalValue": 86435.01,
      "protocolValuePercentage": 6.27
  },
  {
      "rank": 6,
      "protocolName": "Uniswap V3",
      "protocolType": "Liquidity Pool",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/STETH.webp",
      "totalValue": 86074.57,
      "protocolValuePercentage": 6.25
  },
  {
      "rank": 7,
      "protocolName": "Uniswap V3",
      "protocolType": "Liquidity Pool",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/OSETH.webp",
      "totalValue": 77747.64,
      "protocolValuePercentage": 5.64
  },
  {
      "rank": 8,
      "protocolName": "Uniswap V3",
      "protocolType": "Liquidity Pool",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/FRXETH.webp",
      "totalValue": 66827.35,
      "protocolValuePercentage": 4.85
  },
  {
      "rank": 9,
      "protocolName": "Gnosis Safe",
      "protocolType": "Vesting",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/SAFE.webp",
      "totalValue": 6987.81,
      "protocolValuePercentage": 0.51
  },
  {
      "rank": 10,
      "protocolName": "Index Coop",
      "protocolType": "Investment",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/ETH.webp",
      "totalValue": 5987.7,
      "protocolValuePercentage": 0.43
  },
  {
      "rank": 11,
      "protocolName": "Index Coop",
      "protocolType": "Investment",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/STETH.webp",
      "totalValue": 2591.54,
      "protocolValuePercentage": 0.19
  },
  {
      "rank": 12,
      "protocolName": "0xSplits",
      "protocolType": "Deposit",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/UNI.webp",
      "totalValue": 1017.28,
      "protocolValuePercentage": 0.07
  },
  {
      "rank": 13,
      "protocolName": "Compound",
      "protocolType": "Lending",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/COMP.webp",
      "totalValue": 813.97,
      "protocolValuePercentage": 0.06
  },
  {
      "rank": 14,
      "protocolName": "0xSplits",
      "protocolType": "Deposit",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/LDO.webp",
      "totalValue": 656.17,
      "protocolValuePercentage": 0.05
  },
  {
      "rank": 15,
      "protocolName": "Index Coop",
      "protocolType": "Investment",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/OSETH.webp",
      "totalValue": 535.02,
      "protocolValuePercentage": 0.04
  },
  {
      "rank": 16,
      "protocolName": "Index Coop",
      "protocolType": "Investment",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/FRXETH.webp",
      "totalValue": 460.95,
      "protocolValuePercentage": 0.03
  },
  {
      "rank": 17,
      "protocolName": "0xSplits",
      "protocolType": "Deposit",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
      "totalValue": 27.82,
      "protocolValuePercentage": 0
  },
  {
      "rank": 18,
      "protocolName": "0xSplits",
      "protocolType": "Deposit",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/USDC.webp",
      "totalValue": 26.6,
      "protocolValuePercentage": 0
  },
  {
      "rank": 19,
      "protocolName": "Compound",
      "protocolType": "Lending",
      "protocolChainTitle": "Ethereum",
      "protocolChainId": "1",
      "assetLogo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/token/DAI.webp",
      "totalValue": 1.22,
      "protocolValuePercentage": 0
  }
];


export const treasuryDiversificationMock = [
  {
      "datePeriod": "current",
      "totalAum": 10516024.236309186,
      "votingTokenUsdValue": 4021920.2293226235,
      "votingTokenPercentage": 38.24563484207221,
      "stablecoinsUsdValue": 480029.3843737436,
      "stablecoinsPercentage": 4.5647420887099415,
      "ethBtcUsdValue": 3489636.3719855114,
      "ethBtcPercentage": 33.18398943905697,
      "otherTokensUsdValue": 2524438.250627307,
      "otherTokensPercentage": 24.005633630160887
  },
  {
      "datePeriod": "7 days",
      "totalAum": 11636443.415480226,
      "votingTokenUsdValue": 4663845.695386744,
      "votingTokenPercentage": 40.07964915794051,
      "stablecoinsUsdValue": 499967.8487035452,
      "stablecoinsPercentage": 4.296569242440749,
      "ethBtcUsdValue": 3660548.0752167506,
      "ethBtcPercentage": 31.457619347394754,
      "otherTokensUsdValue": 2812081.796173187,
      "otherTokensPercentage": 24.166162252223994
  },
  {
      "datePeriod": "30 days",
      "totalAum": 11568578.879341437,
      "votingTokenUsdValue": 4653738.617841294,
      "votingTokenPercentage": 40.22740101769715,
      "stablecoinsUsdValue": 500285.4931807138,
      "stablecoinsPercentage": 4.324519877494179,
      "ethBtcUsdValue": 3731345.6930497317,
      "ethBtcPercentage": 32.25414056442986,
      "otherTokensUsdValue": 2683209.0752696972,
      "otherTokensPercentage": 23.193938540378817
  },
  {
      "datePeriod": "6 months",
      "totalAum": 14132222.060828889,
      "votingTokenUsdValue": 3953668.215501179,
      "votingTokenPercentage": 27.976267274060135,
      "stablecoinsUsdValue": 5322828.680667473,
      "stablecoinsPercentage": 37.66448515850222,
      "ethBtcUsdValue": 2651296.514053604,
      "ethBtcPercentage": 18.76064855648114,
      "otherTokensUsdValue": 2204428.650606634,
      "otherTokensPercentage": 15.598599010956518
  },
  {
      "datePeriod": "1 year",
      "totalAum": 38730643.162446916,
      "votingTokenUsdValue": 13028709.715465268,
      "votingTokenPercentage": 33.63928055834057,
      "stablecoinsUsdValue": 6643872.524554587,
      "stablecoinsPercentage": 17.154046465710284,
      "ethBtcUsdValue": 15932493.374661505,
      "ethBtcPercentage": 41.1366609840076,
      "otherTokensUsdValue": 3125567.547765553,
      "otherTokensPercentage": 8.070011991941541
  },
  {
      "datePeriod": "2 years",
      "totalAum": 59502001.91464019,
      "votingTokenUsdValue": 35122747.351378515,
      "votingTokenPercentage": 59.027841452737285,
      "stablecoinsUsdValue": 9155529.359650569,
      "stablecoinsPercentage": 15.386926599183706,
      "ethBtcUsdValue": 11525295.274127547,
      "ethBtcPercentage": 19.36959245616878,
      "otherTokensUsdValue": 3698429.9294835553,
      "otherTokensPercentage": 6.215639491910228
  }
];


export const treasuryCompositionMock = {
  "id": "be5110c8-f6f2-493d-a7dd-99d9a87329b2",
  "organizationId": "aca77a4e-ecb1-4eb3-a722-979977a52eb4",
  "data": [
      {
          "date": "2022-09",
          "totalAum": 62334431.76169411,
          "ethBtcUsdValue": 3131839.428373772,
          "ethBtcPercentage": 5.024252792336124,
          "otherTokensUsdValue": 6544948.720916711,
          "stablecoinsUsdValue": 4946227.556947113,
          "votingTokenUsdValue": 47711416.05545651,
          "otherTokensPercentage": 10.499732709424853,
          "stablecoinsPercentage": 7.93498459383836,
          "votingTokenPercentage": 76.54102990440066
      },
      {
          "date": "2022-10",
          "totalAum": 55275719.708119765,
          "ethBtcUsdValue": 2803394.3115682076,
          "ethBtcPercentage": 5.071655921209834,
          "otherTokensUsdValue": 7689656.589147396,
          "stablecoinsUsdValue": 4804043.849948431,
          "votingTokenUsdValue": 39978624.95745573,
          "otherTokensPercentage": 13.911454486259398,
          "stablecoinsPercentage": 8.691056173155062,
          "votingTokenPercentage": 72.32583341937571
      },
      {
          "date": "2022-11",
          "totalAum": 62310943.50173238,
          "ethBtcUsdValue": 2957974.2269995306,
          "ethBtcPercentage": 4.747118340323786,
          "otherTokensUsdValue": 4582406.656800911,
          "stablecoinsUsdValue": 6361144.5643191915,
          "votingTokenUsdValue": 48409418.05361275,
          "otherTokensPercentage": 7.354096085342553,
          "stablecoinsPercentage": 10.208711675409534,
          "votingTokenPercentage": 77.69007389892413
      },
      {
          "date": "2022-12",
          "totalAum": 59332490.07735379,
          "ethBtcUsdValue": 2848269.6241118675,
          "ethBtcPercentage": 4.800522648549692,
          "otherTokensUsdValue": 3869350.5676296353,
          "stablecoinsUsdValue": 10790243.846361203,
          "votingTokenUsdValue": 41824626.03925108,
          "otherTokensPercentage": 6.52147004547598,
          "stablecoinsPercentage": 18.186062699026444,
          "votingTokenPercentage": 70.49194460694788
      },
      {
          "date": "2023-01",
          "totalAum": 70579854.3286031,
          "ethBtcUsdValue": 7534421.86011421,
          "ethBtcPercentage": 10.67503175202902,
          "otherTokensUsdValue": 4943983.298188716,
          "stablecoinsUsdValue": 11102973.24050953,
          "votingTokenUsdValue": 46998475.929790646,
          "otherTokensPercentage": 7.0048080223723606,
          "stablecoinsPercentage": 15.731079847256007,
          "votingTokenPercentage": 66.58908037834262
      },
      {
          "date": "2023-02",
          "totalAum": 90117978.03559212,
          "ethBtcUsdValue": 9889623.59883501,
          "ethBtcPercentage": 10.974085098679312,
          "otherTokensUsdValue": 6773508.559790954,
          "stablecoinsUsdValue": 11525697.212016148,
          "votingTokenUsdValue": 61929148.664950006,
          "otherTokensPercentage": 7.516267794108468,
          "stablecoinsPercentage": 12.789564816316751,
          "votingTokenPercentage": 68.72008229089546
      },
      {
          "date": "2023-03",
          "totalAum": 87673672.96894738,
          "ethBtcUsdValue": 10975792.073434923,
          "ethBtcPercentage": 12.518914403554614,
          "otherTokensUsdValue": 6261643.7762734,
          "stablecoinsUsdValue": 12108438.454536935,
          "votingTokenUsdValue": 58327798.66470213,
          "otherTokensPercentage": 7.1419886543263384,
          "stablecoinsPercentage": 13.810803225759175,
          "votingTokenPercentage": 66.52829371635988
      },
      {
          "date": "2023-04",
          "totalAum": 84811284.897157,
          "ethBtcUsdValue": 12638543.899777954,
          "ethBtcPercentage": 14.901960175586984,
          "otherTokensUsdValue": 6296858.972769007,
          "stablecoinsUsdValue": 11473612.348736975,
          "votingTokenUsdValue": 54402269.67587306,
          "otherTokensPercentage": 7.424553207046255,
          "stablecoinsPercentage": 13.528402927334483,
          "votingTokenPercentage": 64.14508369003228
      },
      {
          "date": "2023-05",
          "totalAum": 81242164.58431551,
          "ethBtcUsdValue": 12409030.430695726,
          "ethBtcPercentage": 15.27412581162491,
          "otherTokensUsdValue": 5777355.254128903,
          "stablecoinsUsdValue": 11627160.285867088,
          "votingTokenUsdValue": 51428618.61362379,
          "otherTokensPercentage": 7.111276864285163,
          "stablecoinsPercentage": 14.311731285544562,
          "votingTokenPercentage": 63.30286603854536
      },
      {
          "date": "2023-06",
          "totalAum": 68966086.24787366,
          "ethBtcUsdValue": 11891207.623248033,
          "ethBtcPercentage": 17.242108796067367,
          "otherTokensUsdValue": 4534219.668776527,
          "stablecoinsUsdValue": 11254450.63704658,
          "votingTokenUsdValue": 41286208.31880252,
          "otherTokensPercentage": 6.574564275664294,
          "stablecoinsPercentage": 16.31881878376645,
          "votingTokenPercentage": 59.86450814450188
      },
      {
          "date": "2023-07",
          "totalAum": 63385283.33395332,
          "ethBtcUsdValue": 12509334.900419906,
          "ethBtcPercentage": 19.735393205569352,
          "otherTokensUsdValue": 4385653.171992198,
          "stablecoinsUsdValue": 8484153.1853053,
          "votingTokenUsdValue": 38006142.07623592,
          "otherTokensPercentage": 6.919040100973965,
          "stablecoinsPercentage": 13.385052080000136,
          "votingTokenPercentage": 59.96051461345655
      },
      {
          "date": "2023-08",
          "totalAum": 58680877.82797501,
          "ethBtcUsdValue": 12199174.103660425,
          "ethBtcPercentage": 20.78901092690317,
          "otherTokensUsdValue": 3972966.3768914416,
          "stablecoinsUsdValue": 6465508.310221752,
          "votingTokenUsdValue": 36043229.0372014,
          "otherTokensPercentage": 6.770461731227552,
          "stablecoinsPercentage": 11.018083828220174,
          "votingTokenPercentage": 61.42244351364911
      },
      {
          "date": "2023-09",
          "totalAum": 53829499.097413234,
          "ethBtcUsdValue": 11209177.258904839,
          "ethBtcPercentage": 20.823484236069167,
          "otherTokensUsdValue": 3536264.9904816,
          "stablecoinsUsdValue": 6655266.488670789,
          "votingTokenUsdValue": 32428790.35935601,
          "otherTokensPercentage": 6.569381193910338,
          "stablecoinsPercentage": 12.363604715375489,
          "votingTokenPercentage": 60.243529854645004
      },
      {
          "date": "2023-10",
          "totalAum": 55679765.132137835,
          "ethBtcUsdValue": 10885058.150437975,
          "ethBtcPercentage": 19.549396669698275,
          "otherTokensUsdValue": 3783042.659031205,
          "stablecoinsUsdValue": 8778738.082507145,
          "votingTokenUsdValue": 32232926.24016151,
          "otherTokensPercentage": 6.794286308595917,
          "stablecoinsPercentage": 15.76647829184204,
          "votingTokenPercentage": 57.88983872986376
      },
      {
          "date": "2023-11",
          "totalAum": 62357390.15648279,
          "ethBtcUsdValue": 12934089.698645446,
          "ethBtcPercentage": 20.74187143847423,
          "otherTokensUsdValue": 3777507.6179487333,
          "stablecoinsUsdValue": 8744440.2297066,
          "votingTokenUsdValue": 36901352.61018201,
          "otherTokensPercentage": 6.057834698452363,
          "stablecoinsPercentage": 14.02310168492116,
          "votingTokenPercentage": 59.17719217815224
      },
      {
          "date": "2023-12",
          "totalAum": 69413232.96280389,
          "ethBtcUsdValue": 14628915.084413704,
          "ethBtcPercentage": 21.075109831367207,
          "otherTokensUsdValue": 4453783.678160973,
          "stablecoinsUsdValue": 8246567.554834018,
          "votingTokenUsdValue": 42083966.64539519,
          "otherTokensPercentage": 6.416332287170083,
          "stablecoinsPercentage": 11.880396867918636,
          "votingTokenPercentage": 60.62816101354408
      },
      {
          "date": "2024-01",
          "totalAum": 69781069.37932,
          "ethBtcUsdValue": 15158602.053484615,
          "ethBtcPercentage": 21.723086487947903,
          "otherTokensUsdValue": 5093331.718782514,
          "stablecoinsUsdValue": 7913341.802379376,
          "votingTokenUsdValue": 41615793.80467349,
          "otherTokensPercentage": 7.299016429650691,
          "stablecoinsPercentage": 11.340241519320337,
          "votingTokenPercentage": 59.63765556308107
      },
      {
          "date": "2024-02",
          "totalAum": 79027311.38576797,
          "ethBtcUsdValue": 17931670.64123917,
          "ethBtcPercentage": 22.69047285906842,
          "otherTokensUsdValue": 5625544.602089182,
          "stablecoinsUsdValue": 7749289.997964224,
          "votingTokenUsdValue": 47720806.14447539,
          "otherTokensPercentage": 7.118481577373119,
          "stablecoinsPercentage": 9.805837832615161,
          "votingTokenPercentage": 60.3852077309433
      },
      {
          "date": "2024-03",
          "totalAum": 107752193.48137708,
          "ethBtcUsdValue": 23708897.130381867,
          "ethBtcPercentage": 22.003168904844152,
          "otherTokensUsdValue": 7726679.549158752,
          "stablecoinsUsdValue": 7427889.099884643,
          "votingTokenUsdValue": 68888727.70195182,
          "otherTokensPercentage": 7.170786319532476,
          "stablecoinsPercentage": 6.893492243541578,
          "votingTokenPercentage": 63.9325525320818
      },
      {
          "date": "2024-04",
          "totalAum": 84211385.43192689,
          "ethBtcUsdValue": 21554873.131537855,
          "ethBtcPercentage": 25.59615071166588,
          "otherTokensUsdValue": 6231576.387797266,
          "stablecoinsUsdValue": 7872836.36535107,
          "votingTokenUsdValue": 48552099.5472407,
          "otherTokensPercentage": 7.399921466479878,
          "stablecoinsPercentage": 9.348897806360347,
          "votingTokenPercentage": 57.65503001549389
      },
      {
          "date": "2024-05",
          "totalAum": 76916330.52636692,
          "ethBtcUsdValue": 21828619.09174187,
          "ethBtcPercentage": 28.379693808012618,
          "otherTokensUsdValue": 5957533.98394376,
          "stablecoinsUsdValue": 8060843.170487123,
          "votingTokenUsdValue": 41069334.28019417,
          "otherTokensPercentage": 7.745473481605466,
          "stablecoinsPercentage": 10.480015252058685,
          "votingTokenPercentage": 53.39481745832324
      },
      {
          "date": "2024-06",
          "totalAum": 74990710.71065675,
          "ethBtcUsdValue": 21951065.459585913,
          "ethBtcPercentage": 29.27171279157713,
          "otherTokensUsdValue": 6072914.136042967,
          "stablecoinsUsdValue": 7152140.882181129,
          "votingTokenUsdValue": 39814590.232846744,
          "otherTokensPercentage": 8.098221871072306,
          "stablecoinsPercentage": 9.537369114658565,
          "votingTokenPercentage": 53.092696222692005
      },
      {
          "date": "2024-07",
          "totalAum": 57408346.517040275,
          "ethBtcUsdValue": 20158691.44224307,
          "ethBtcPercentage": 35.1145655035709,
          "otherTokensUsdValue": 5431208.423469685,
          "stablecoinsUsdValue": 6867426.26700542,
          "votingTokenUsdValue": 24951020.384322096,
          "otherTokensPercentage": 9.460659909195543,
          "stablecoinsPercentage": 11.962417807952352,
          "votingTokenPercentage": 43.462356779281194
      },
      {
          "date": "2024-08",
          "totalAum": 50880957.719897985,
          "ethBtcUsdValue": 18924736.131263975,
          "ethBtcPercentage": 37.19414291579478,
          "otherTokensUsdValue": 4826943.298166245,
          "stablecoinsUsdValue": 7582802.120466034,
          "votingTokenUsdValue": 19546476.170001727,
          "otherTokensPercentage": 9.486738289673694,
          "stablecoinsPercentage": 14.903025533068204,
          "votingTokenPercentage": 38.41609326146332
      },
      {
          "date": "2024-09",
          "totalAum": 38110047.66385077,
          "ethBtcUsdValue": 14941512.880343935,
          "ethBtcPercentage": 39.20622984294162,
          "otherTokensUsdValue": 2942292.9936816692,
          "stablecoinsUsdValue": 6597964.769683515,
          "votingTokenUsdValue": 13628277.020141652,
          "otherTokensPercentage": 7.720517748059856,
          "stablecoinsPercentage": 17.312927099647805,
          "votingTokenPercentage": 35.760325309350726
      },
      {
          "date": "2024-10",
          "totalAum": 38026216.49829257,
          "ethBtcUsdValue": 15510887.680534672,
          "ethBtcPercentage": 40.78998414483632,
          "otherTokensUsdValue": 3170652.431518145,
          "stablecoinsUsdValue": 6831937.779366305,
          "votingTokenUsdValue": 12512738.606873453,
          "otherTokensPercentage": 8.338069688475349,
          "stablecoinsPercentage": 17.966388477468087,
          "votingTokenPercentage": 32.90555768922025
      },
      {
          "date": "2024-11",
          "totalAum": 40908422.69397613,
          "ethBtcUsdValue": 18167823.73190651,
          "ethBtcPercentage": 44.41096120428464,
          "otherTokensUsdValue": 3373233.173729457,
          "stablecoinsUsdValue": 7053485.747675832,
          "votingTokenUsdValue": 12313880.040664328,
          "otherTokensPercentage": 8.245815779707817,
          "stablecoinsPercentage": 17.242135685457452,
          "votingTokenPercentage": 30.101087330550097
      },
      {
          "date": "2024-12",
          "totalAum": 48947315.512209035,
          "ethBtcUsdValue": 20934221.40245537,
          "ethBtcPercentage": 42.76888565468662,
          "otherTokensUsdValue": 4866500.826735906,
          "stablecoinsUsdValue": 6331136.179745224,
          "votingTokenUsdValue": 16815457.10327253,
          "otherTokensPercentage": 9.942324263977346,
          "stablecoinsPercentage": 12.934593273386024,
          "votingTokenPercentage": 34.35419680795
      },
      {
          "date": "2025-01",
          "totalAum": 40246916.00685906,
          "ethBtcUsdValue": 19083126.82835369,
          "ethBtcPercentage": 47.41512821777813,
          "otherTokensUsdValue": 4029970.0446009785,
          "stablecoinsUsdValue": 5946094.021445783,
          "votingTokenUsdValue": 11187725.112458602,
          "otherTokensPercentage": 10.01311515126817,
          "stablecoinsPercentage": 14.774036401776533,
          "votingTokenPercentage": 27.797720229177163
      },
      {
          "date": "2025-02",
          "totalAum": 30927389.9960957,
          "ethBtcUsdValue": 15044542.432962032,
          "ethBtcPercentage": 48.6447205369133,
          "otherTokensUsdValue": 3000161.913468022,
          "stablecoinsUsdValue": 5610513.426581522,
          "votingTokenUsdValue": 7272172.22308412,
          "otherTokensPercentage": 9.700663113980083,
          "stablecoinsPercentage": 18.1409211294254,
          "votingTokenPercentage": 23.513695219681214
      },
      {
          "date": "2025-03",
          "totalAum": 22744619.499138664,
          "ethBtcUsdValue": 9958853.231780186,
          "ethBtcPercentage": 43.78553456195355,
          "otherTokensUsdValue": 2440312.8370773457,
          "stablecoinsUsdValue": 5368983.382256964,
          "votingTokenUsdValue": 4976470.048024168,
          "otherTokensPercentage": 10.729187345472013,
          "stablecoinsPercentage": 23.60550978863501,
          "votingTokenPercentage": 21.87976830393943
      },
      {
          "date": "2025-04",
          "totalAum": 13676130.440995384,
          "ethBtcUsdValue": 2425520.6046794695,
          "ethBtcPercentage": 17.735430465102624,
          "otherTokensUsdValue": 2014008.6005883478,
          "stablecoinsUsdValue": 6124873.359623357,
          "votingTokenUsdValue": 3111727.876104209,
          "otherTokensPercentage": 14.726450652672796,
          "stablecoinsPercentage": 44.78513411413157,
          "votingTokenPercentage": 22.752984768092997
      },
      {
          "date": "2025-05",
          "totalAum": 13455411.562623687,
          "ethBtcUsdValue": 1917412.8313774152,
          "ethBtcPercentage": 14.250123992517524,
          "otherTokensUsdValue": 2542217.3847520575,
          "stablecoinsUsdValue": 5626407.44910857,
          "votingTokenUsdValue": 3369373.8973856443,
          "otherTokensPercentage": 18.89364270219578,
          "stablecoinsPercentage": 41.81520143714928,
          "votingTokenPercentage": 25.041031868137413
      },
      {
          "date": "2025-06",
          "totalAum": 9599429.099224921,
          "ethBtcUsdValue": 2000655.126141891,
          "ethBtcPercentage": 20.841396977487218,
          "otherTokensUsdValue": 2366821.272164829,
          "stablecoinsUsdValue": 2158336.18568766,
          "votingTokenUsdValue": 3073616.5152305407,
          "otherTokensPercentage": 24.655854506555304,
          "stablecoinsPercentage": 22.484005698442303,
          "votingTokenPercentage": 32.018742817515175
      },
      {
          "date": "2025-07",
          "totalAum": 9297665.021062661,
          "ethBtcUsdValue": 2698340.209886994,
          "ethBtcPercentage": 29.021697423753736,
          "otherTokensUsdValue": 2775340.558955919,
          "stablecoinsUsdValue": 175454.6750719973,
          "votingTokenUsdValue": 3648529.57714775,
          "otherTokensPercentage": 29.849866097227025,
          "stablecoinsPercentage": 1.887083205025427,
          "votingTokenPercentage": 39.24135327399381
      },
      {
          "date": "2025-08",
          "totalAum": 11638451.256755771,
          "ethBtcUsdValue": 3603817.505416316,
          "ethBtcPercentage": 30.964751459730593,
          "otherTokensUsdValue": 2945056.535151826,
          "stablecoinsUsdValue": 447832.5607135901,
          "votingTokenUsdValue": 4641744.65547404,
          "otherTokensPercentage": 25.30453984109191,
          "stablecoinsPercentage": 3.847870741853533,
          "votingTokenPercentage": 39.88283795732397
      },
      {
          "date": "2025-09",
          "totalAum": 11684634.719969532,
          "ethBtcUsdValue": 3685074.782697937,
          "ethBtcPercentage": 31.537783345507492,
          "otherTokensUsdValue": 2790996.215975493,
          "stablecoinsUsdValue": 496125.08573266177,
          "votingTokenUsdValue": 4712438.63556344,
          "otherTokensPercentage": 23.886037371844953,
          "stablecoinsPercentage": 4.245961449567296,
          "votingTokenPercentage": 40.33021783308026
      }
  ],
  "createdAt": "2025-09-30T04:00:31.429Z"
}